import { graphql, useStaticQuery } from 'gatsby'
import { RibbonBlok } from '../utils/storyblok'

export const useGlobalRibbonData = (): RibbonBlok | null => {
    const data = useStaticQuery(graphql`
        query {
            allStoryblokEntry(
                filter: {field_component: {eq: "ribbon"}} 
                limit: 1 
                sort: {created_at: DESC}
            ) {
                nodes {
                    blokStr: content
                }
            }
        }
  `)

    const { blokStr } = data.allStoryblokEntry.nodes[0] ?? {}
    if (!blokStr) {
        return null
    }

    return JSON.parse(blokStr) as RibbonBlok
}
